import { __PROD__, __STAGING__ } from "./utils/dev";

export const config = {
  // Set to true to restore the single-token $AGI pool and its staking entry points.
  AGI_STAKING_POOL_ENABLED: false,
  GA_MEASUREMENT_ID: "G-K5HWHPL62Y",
  DELYSIUM_CLIENT_URL: __PROD__ ? "https://www.delysium.com/" : "https://www-staging.delysium.com/",
  MARKETPLACE_CLIENT_URL: __PROD__
    ? "https://marketplace.delysium.com/"
    : __STAGING__
    ? "https://marketplace-staging.delysium.com/"
    : "https://marketplace-dev.delysium.com/",
  SSO_CLIENT_URL: __PROD__
    ? "https://auth.delysium.com"
    : __STAGING__
    ? "https://auth-staging.delysium.com"
    : "https://auth-dev.delysium.com",
  DASHBOARD_UI: __PROD__
    ? "https://dashboard.delysium.com/"
    : __STAGING__
    ? "https://dashboard-staging.delysium.com/"
    : "https://dashboard-dev.delysium.com/",
  SSO_API_URL: __PROD__
    ? "https://sso.delysium.com"
    : __STAGING__
    ? "https://sso-stg.delysium.com"
    : "https://sso-dev.delysium.com",
  MARKET_API_URL: __PROD__
    ? "https://market-api.delysium.com/api/v1"
    : __STAGING__
    ? "https://market-api-staging.delysium.com/api/v1"
    : "https://market-api-dev.delysium.com/api/v1",
  SYNCER_API_URL: __PROD__
    ? "https://syncer-bsc-api.delysium.com/api/v1"
    : "https://syncer-api-staging.delysium.com/api/v1",
  DMA_API_URL: __PROD__
    ? "https://dma-api.delysium.com/api/v1"
    : __STAGING__
    ? "https://dma-api-staging.delysium.com/api/v1"
    : "https://dma-api-dev.delysium.com/api/v1"
};
